import React from 'react';
import PropTypes from 'prop-types';
import { passwordLabels } from '../../lib/i18n';

const AUPasswordRequirementsComponents = ({ lang }) => (
  <div className="row__item row__item--basis-25">
    <div className="box box--constrain-width theme--background-secondary row__item-content">
      <h2 className="text--default-size text--pull">{passwordLabels[lang].requirementsHeader}</h2>
      <ul className="list--dense">
        <li>{passwordLabels[lang].requirement1}</li>
        <li>{passwordLabels[lang].requirement2}</li>
        <li>{passwordLabels[lang].requirement3}</li>
        <li>
          {passwordLabels[lang].requirement4}
          &nbsp;
          <span className="u-avoid-wrap">
            {'~!@#$%^&*_-+=`|(){}[]:;"\'<>,.?/'}
          </span>
        </li>
      </ul>
    </div>
  </div>
);

AUPasswordRequirementsComponents.propTypes = {
  lang: PropTypes.string.isRequired,
};
AUPasswordRequirementsComponents.displayName = 'AUPasswordRequirementsComponents';
export default AUPasswordRequirementsComponents;
